var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9867 16.9414C14.1992 16.9414 14.573 17.1193 15.084 17.6739C17.7307 20.5512 20.706 22.8257 23.208 24.1988C23.5667 24.3977 23.7672 24.5439 23.7672 24.7338C23.7672 24.8755 23.7476 25.0202 23.4341 25.0202C22.8719 25.0202 19.7172 24.3977 18.8837 24.0058C18.0457 23.6139 16.243 22.1489 14.0922 18.4441C13.8495 18.0266 13.5918 17.6649 13.5918 17.3288C13.5918 16.9942 13.8978 16.9414 13.9867 16.9414Z",
    fill: "#6C9BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1301 6.3528C21.1301 6.3528 21.6531 7.38676 16.5586 8.1027C17.1133 6.52914 17.4811 5.49367 17.4811 5.49367C17.8051 4.55316 17.0756 4 16.5496 4C16.022 4 15.6392 4.40394 15.4207 4.91188L13.9059 8.37853C11.9193 8.51116 10.4468 8.44183 9.78209 8.37551C8.85815 8.28357 8.62151 8.79603 8.62151 9.31753C8.62151 10.2279 10.2252 11.1518 11.2501 11.0509C11.8982 10.9906 12.2735 10.9619 12.7996 10.9092L7.16703 23.784C6.953 24.2648 6.77967 25.0365 7.74581 25.0365C8.71345 25.0365 10.8899 24.1548 11.2531 23.1299C11.4069 22.6988 12.5283 19.52 13.7793 15.978C14.3957 15.8544 16.6717 15.5047 17.3047 15.5047C17.9046 15.5047 18.2136 15.7745 18.2136 16.0941C18.2136 16.8356 16.435 18.9623 12.9895 21.5849C12.6097 21.8728 12.9232 22.1004 13.1176 22.1004C13.6497 22.1004 16.0251 20.4726 17.2022 19.5833C18.4954 18.6081 20.7518 16.0669 20.7518 14.2824C20.7518 13.577 20.4398 12.9319 19.026 12.9319C17.6559 12.9319 15.2383 13.2364 14.7228 13.3027C15.0574 12.3501 15.389 11.4186 15.6965 10.5459C18.3628 10.1767 19.9529 9.93701 20.8889 9.74107C22.1776 9.46675 23.2131 8.7267 23.2131 7.96253C23.2131 6.33471 21.1301 6.3528 21.1301 6.3528Z",
    fill: "#6A2D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/한국투자증권-30.5d4deb2775a0699a09624bc13d096394.svg";
export { ForwardRef as ReactComponent };